<template>
  <div class="footer text-white">
    <!-- <div class="footer__socials flex flex-wrap w-full justify-center my-6">
      <a href="https://www.facebook.com/almouj.muscat/" target="_blank"><img :src="require('../assets/facebook.svg')"></a>
      <a href="https://www.instagram.com/almoujmuscat/" target="_blank"><img :src="require('../assets/instagram.svg')"></a>
      <a href="https://www.youtube.com/user/WaveMuscat" target="_blank"><img :src="require('../assets/youtube.svg')"></a>
    </div> -->
    <div class="footer__socials flex flex-wrap w-full justify-center mb-5">
      <a href="https://www.facebook.com/almouj.muscat/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#0e1938" stroke="#0e1938" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-facebook"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg></a>
      <a href="https://www.instagram.com/almoujmuscat/" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#0e1938" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-instagram"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg></a>
      <a href="https://www.youtube.com/user/WaveMuscat" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#0e1938" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-youtube"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon></svg></a>
    </div>
    <div class="footer__details">
      <div class="text-right">
        <span>International</span><br>
        <span>Oman</span>
      </div>
      <div class="text-left mb-4">
        <a href="tel:+96824534444">+968 2453 4444</a><br>
        <a href="tel:80077776">8007 7776</a>
      </div>
    </div>
    <div class="text-sm text-center">
      The Walk Mall Street No. 6<br>
      Muscat 138<br>
      Oman<br>
      <a class="block mt-3" href="https://almouj.com"><span>almouj.com</span></a>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
@import '@/assets/styles/_variables';
.footer {
  background-color: $navy;
  border-top: 1px solid #fff;
  padding: 30px 0;

  &__socials {
    display: flex;
    justify-content: center;

    a {
      background: #fff;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      margin: 0 5px;
      position: relative;
      width: 40px;
      // opacity: 0.8;

      &:hover,
      &:focus {
        opacity: 0.8;
      }
    }
  }

  &__details {
    display: flex;

    > div {
      line-height: 1.3;
      padding: 0.5em;
      width: 50%;
    }
  }

  span {
    font-size: 14px;
    opacity: 0.8;
  }  
}
</style>